import(/* webpackMode: "eager" */ "/var/www/apporb-web/frontend/src/app/docs/layout.tsx");
